import * as React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import DependencyInjection from './DependencyInjection';
import Home from './Home';
import RoomIndex from './rooms/Index';
import MotelRoom from './rooms/MotelRoom';
import EfficiencyRoom from './rooms/EfficiencyRoom';
import BedroomSuite from './rooms/BedroomSuite';
import Booking from './booking/New';

import './widgets/widgets.less';

export default class App extends React.Component<{}, {}> {

    render(): JSX.Element {
        return (
            <DependencyInjection>
              <Router history={ browserHistory }>
                <Route path="/">
                  <Route path="/rooms" component={ RoomIndex } />
                  <Route path="/motel-room" component={ MotelRoom } />
                  <Route path="/efficiency-room" component={ EfficiencyRoom } />
                  <Route path="/bedroom-suite" component={ BedroomSuite } />
                  <Route path="/booking/from/:arrival/thru/:departure" component={ Booking } />
                  <IndexRoute component={ Home } />
                </Route>
              </Router>
            </DependencyInjection>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/App.tsx
 **/